/**
 * Énumérations du module agenda (épopée E26).
 * Référence : document 09 — US-E26-01 à US-E26-05.
 */
/** Nature d'un événement d'agenda : rendez-vous ou tâche planifiée. */
export const CALENDAR_EVENT_KINDS = ['appointment', 'task'];
/** Statuts d'un événement d'agenda. */
export const CALENDAR_EVENT_STATUSES = ['tentative', 'confirmed', 'cancelled'];
/** Statuts de présence d'un participant. */
export const CALENDAR_ATTENDEE_STATUSES = ['invited', 'tentative', 'accepted', 'declined'];
/** Canaux de diffusion d'un rappel d'événement. */
export const CALENDAR_REMINDER_CHANNELS = ['in_app', 'email', 'sms'];
/** Périmètre d'un contact externe rattaché à un événement. */
export const CALENDAR_CONTACT_SCOPES = ['prospect', 'client'];
/** Fournisseurs d'agenda externe raccordables (US-E26-06). */
export const CALENDAR_PROVIDERS = ['google', 'microsoft', 'ics'];
/** Sens de synchronisation d'une connexion d'agenda externe. */
export const CALENDAR_SYNC_DIRECTIONS = ['push', 'pull', 'both'];
/** États d'une connexion d'agenda externe. */
export const CALENDAR_SYNC_STATUSES = ['active', 'expired', 'revoked', 'error'];
//# sourceMappingURL=calendar.enum.js.map